// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReviewStatus } from './review-status';
import {
    ReviewStatusFromJSON,
    ReviewStatusFromJSONTyped,
    ReviewStatusToJSON,
    ReviewStatusToJSONTyped,
} from './review-status';

/**
 * 
 * @export
 * @interface UpdateRunRequestContent
 */
export interface UpdateRunRequestContent {
    /**
     * 
     * @type {string}
     * @memberof UpdateRunRequestContent
     */
    assignedTo?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRunRequestContent
     */
    resolution?: string;
    /**
     * 
     * @type {ReviewStatus}
     * @memberof UpdateRunRequestContent
     */
    reviewStatus?: ReviewStatus;
}



/**
 * Check if a given object implements the UpdateRunRequestContent interface.
 */
export function instanceOfUpdateRunRequestContent(value: object): value is UpdateRunRequestContent {
    return true;
}

export function UpdateRunRequestContentFromJSON(json: any): UpdateRunRequestContent {
    return UpdateRunRequestContentFromJSONTyped(json, false);
}

export function UpdateRunRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRunRequestContent {
    if (json == null) {
        return json;
    }
    return {
        
        'assignedTo': json['assignedTo'] == null ? undefined : json['assignedTo'],
        'resolution': json['resolution'] == null ? undefined : json['resolution'],
        'reviewStatus': json['reviewStatus'] == null ? undefined : ReviewStatusFromJSON(json['reviewStatus']),
    };
}

export function UpdateRunRequestContentToJSON(json: any): UpdateRunRequestContent {
    return UpdateRunRequestContentToJSONTyped(json, false);
}

export function UpdateRunRequestContentToJSONTyped(value?: UpdateRunRequestContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assignedTo': value['assignedTo'],
        'resolution': value['resolution'],
        'reviewStatus': ReviewStatusToJSON(value['reviewStatus']),
    };
}
